import { formatDuration } from 'date-fns'

export const getCourseTime = (chapters, hasSubchapters) => {
  let totalTimeSeconds = 0

  if (hasSubchapters) {
    totalTimeSeconds = chapters.reduce((acum, chapter) => {
      if (!chapter.duration || !chapter.startTime || !chapter.endTime)
        return acum
      // For subchapters, duration is endTime - startTime
      return acum + (chapter.endTime - chapter.startTime)
    }, 0)
  } else {
    // Loop through each chapter duration
    for (let i = chapters.length - 1; i >= 0; i -= 1) {
      if (!chapters[i].duration) break

      const durationSplit = chapters[i].duration.split(':')
      let hours = '0'
      if (durationSplit.length === 3) {
        hours = durationSplit.shift()
      }
      const [minutes, seconds] = durationSplit
      totalTimeSeconds += parseInt(hours, 10) * 60 * 60
      totalTimeSeconds += parseInt(minutes, 10) * 60
      totalTimeSeconds += parseInt(seconds, 10)
    }
  }

  return formatDuration({
    hours: Math.floor(totalTimeSeconds / 60 / 60),
    minutes: Math.floor(totalTimeSeconds / 60) % 60,
  })
}

export const getChaptersCount = (chapters) =>
  chapters ? chapters.length : null

export const formatMetadata = ({
  // eslint-disable-next-line camelcase
  facebook_structured_data = {},
  // eslint-disable-next-line camelcase
  twitter_structured_data = [],
  // eslint-disable-next-line camelcase
  course_structured_data = {},
}) => {
  // eslint-disable-next-line camelcase
  const twitter = twitter_structured_data.reduce(
    (obj, item) => Object.assign(obj, { [item.name]: item.content }),
    {},
  )

  return {
    // eslint-disable-next-line camelcase
    description: course_structured_data.description,
    // eslint-disable-next-line camelcase
    facebook: facebook_structured_data,
    // eslint-disable-next-line camelcase
    name: course_structured_data.provider?.brand,
    twitter,
    // eslint-disable-next-line camelcase
    url: course_structured_data.url,
  }
}
